import axios from "axios";
import Vue from "vue";
import store from "./index";
import router from "../router";

export default {
    namespaced: true,
    state: {
        menu: null,
        activeMenu: null,
        search: {
            query: null,
            items: null
        },
        currentItem: null,
    },
    mutations: {
        setMenu(state, val){
            state.menu = val;
            state.menu.findCategoryById = findCategoryById.bind(state.menu);
            state.menu.findProductByName = findProductByName.bind(state.menu);
            state.menu.findProductsByName = findProductsByName.bind(state.menu);
            state.menu.findProductById = findProductById.bind(state.menu);
        },
        setCurrentItem(state,val){
            if (val){
                if (val.asItIs){
                    val = val.item;
                }else{
                    val = { activeModifiers: {}, quantity: 1 , quantityStep : 1 , quantityMin: 1, quantityMax: 1000,  ...val};
                }
                val.totalPrice = totalPrice.bind(val);
                val.changeQuantity = changeQuantity.bind(val);
                val.toggleOption = toggleOption.bind(val);
                val.totalCall = totalCall.bind(val);
                val.changeOptionCount = changeOptionCount.bind(val);
                val.modifiers.map(r=>{
                    if(r.quantity_ability == 1){
                        r.options.map(opt => {
                            Vue.set(opt,"quantity", opt.quantity ?? 0);
                        })
                    }
                });
                state.currentItem = val;
            }else{
                state.currentItem = null;
            }
        }
    },
    actions: {
        getMenuCategories(store,val){
            const bus_id = router.currentRoute.params.business_id || store.rootState.shared.businessId;
            axios.get(`/unauth/businesses/${bus_id}/menu`).then(res=>{
                store.commit("setMenu", res.data);
            })
        },
        getMenuItem(store,{itemId, callback, justReturn}){
            const bus_id = store.rootState.shared.businessId;
            axios.get(`/unauth/businesses/${bus_id}/menu/items/${itemId}`).then(res=>{
                if (!justReturn){
                    store.commit("setCurrentItem", res.data);
                }
                callback?.(res.data);
            })
        }
    }
}


//#########################################################
//Find Product In Array
 const findProductById = function (id, cat){
    if (!id) return false;
    if (!cat) cat = this;

    for (let i=0; i< cat.length; i++){
        const el = cat[i];

        for (let x=0; x< el.menu_items.length; x++){
            const product = el.menu_items[x];

            //console.log("Product ",product.menu_id, id);
            if (id === product.menu_id) {
                //console.log(el);
                product.category = {id: el.id, name: el.name}
                return product;
            }
        }

        if (el.subcategories.length) {
            let found = false;
            found = this.findProductByName(id, el.subcategories);
            if (found) return found;
        }
    }
    return false;
};

//Find Product In Array
 const findProductByName = function (query, cat){
    if (!query) return false;
    if (!cat) cat = this;

    for (let i=0; i< cat.length; i++){
        const el = cat[i];

        for (let x=0; x< el.menu_items.length; x++){
            const product = el.menu_items[x];
            if (query.toLowerCase() === product.menu_title.toLowerCase()) {
                return product;
            }
        }

        if (el.subcategories.length) {
            let found = false;
            found = this.findProductByName(query, el.subcategories);
            if (found) return found;
        }
    }
    return false;
};

//Find ProductSSSS In Array
const findProductsByName = function (query, cat) {
     if (!query) return false;
     if (!cat) cat = this;
     let arr = [];
     for (let i=0; i< cat.length; i++){
         const el = cat[i];
         for (let x=0; x< el.menu_items.length; x++){
             const product = el.menu_items[x];
             let searchArr = query.split(" ");
             let foundAll = true;
             for (let i=0; i < searchArr.length; i++){
                 if (product.menu_title.toLowerCase().indexOf(searchArr[i].toLowerCase()) === -1) {
                     foundAll = false;
                     break;
                 }
             }
             if (foundAll) arr.push(product);
         }

         if (el.subcategories.length) {
             this.findProductsByName(query, el.subcategories);
         }
     }
     return arr;
};

//Find Product In Array By ID
const findCategoryById  = function (id, cat){
    if (!id) return false;
    if (!cat) cat = this;

    for (let i=0; i< cat.length; i++){
        const el = cat[i];

        if (el.id == id){
            return el
        }

        if (el.subcategories.length) {
            let found = false;
            found = this.findCategoryById(id, el.subcategories);
            if (found) return found;
        }
    }
    return false;
}

///#####################################################
const totalPrice  = function (){
    let priceOfProduct = parseFloat(this.menu_price);
    if(this.activeModifiers){
        for (let [key, value] of Object.entries(this.activeModifiers)) {
            priceOfProduct += parseFloat(value.cost * ( value.quantity ?? 1 ));
        }
    }
    return (this.quantity * priceOfProduct).toFixed(2);
}
const totalCall  = function (){
    if(this.nutritional_facts !== null){
        return this.nutritional_facts.total_calories * this.quantity
    }

}
const changeQuantity  = function (q){
    if(this.quantity+ q >= this.quantityMin){
        this.quantity += q;
    }
}
const toggleOption  = function (option){
    if (this.activeModifiers[option.id]) {
        Vue.delete(this.activeModifiers, option.id);
    } else {
        let addon = this.modifiers.find(el => el.id === option.addon_id);
        //console.log(option);
        if (addon.quantity_ability == 1){
            return false;
        }
        let totalSelected = 0;

        Object.keys(this.activeModifiers).map(key => {
            const value = this.activeModifiers[key]
            if (value.addon_id == addon.id) {
                if (addon.multiple_max == 1) {
                    Vue.delete(this.activeModifiers, value.id);
                } else {
                    totalSelected++
                }
            }
        });

        if (addon.multiple_max == totalSelected ){
            store.commit("shared/setAlert", "<h5><span>You have reached the maximum number of modifications</span></h5>")
        }else{
            option.addon_title = addon.title;
            Vue.set(this.activeModifiers, option.id, option);
        }
    }
}


const changeOptionCount = function(val,option,addon){
    let curentmenuId = parseInt(this.menu_id);
    option.quantity = option.quantity + parseInt(val);
    let sum = 0;
    addon.options.map(opt => { sum += parseInt(opt.quantity) });
    if (option.quantity < 0){
        option.quantity = 0;
        return false;
    }
    //console.log(option)
    //console.log(addon)
    if (sum > addon.max_quantity) {
        option.quantity = option.quantity - val;
        if(curentmenuId == 27144082){
            store.commit("shared/setAlert","<h5>To Purchase 6 or more bagels, please order a half dozen or dozen bagels</h5>")
        }else if(curentmenuId == 27144083){
            store.commit("shared/setAlert","<h5>To Purchase more 7 or more bagels, please order a dozen bagels</h5>")
        }else if(curentmenuId == 27144085){
            store.commit("shared/setAlert","<h5>To Purchase more than a dozen bagels, please add this item to your cart and add an additional dozen bagel item</h5>")
        }else{
            store.commit("shared/setAlert","<h5>You have reached the maximum quantity of modifications</h5>")
        }

        return false;
    }

    if ( addon.min_quantity <= sum){
        addon.options.filter(opt=> opt.quantity > 0 ).map(opt => {
            opt.addon_title = addon.title;
            Vue.set(this.activeModifiers, opt.id, opt);
        });
    }else if(addon.min_quantity > sum && this.activeModifiers[option.id]){
        Object.keys(this.activeModifiers).map(key => {
            if (this.activeModifiers[key].addon_title === addon.title){
                Vue.delete(this.activeModifiers, key);
            }
        });
    }
}
